import PopUpContainer from "../../pop-up-panels/common/PopUpContainer";
import InputFile from "../../placeholders/InputFile";
import { useContext } from "react";
import { CreateEditLessonContext } from "components/utils/Contexts";
import OptionsCard from "../../pop-up-panels/options-pop-up/OptionsCard";

interface AddInstructionsPopUpProps {
  onClose: () => void;
  setShowSBSInstructionsPopUp: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddInstructionsPopUp: React.FC<AddInstructionsPopUpProps> = ({
  setShowSBSInstructionsPopUp,
  onClose,
}) => {
  // Use context parameters
  const { setPlanDocument, setPlanName, setPlanSize } = useContext(
    CreateEditLessonContext,
  );

  /**
   * Function used when pressing back
   */
  const handlePressBack = () => {
    onClose();
  };

  /**
   * Function executed when clicking step by step instructions option
   */
  const handleClickAddStepByStepInstructions = () => {
    // Open step by step instructions
    setShowSBSInstructionsPopUp(true);

    // And close this one
    onClose();
  };

  return (
    <PopUpContainer
      title="Pick an option"
      onPressBack={handlePressBack}
      onClose={onClose}
    >
      <div className="flex flex-col gap-8">
        {/* Upload PDF option */}
        <InputFile
          title="Upload a PDF"
          setFile={setPlanDocument}
          setFilename={setPlanName}
          setFilesize={setPlanSize}
          onLoadEnd={onClose}
          keyName="plan-document"
        />

        {/* Separator */}
        <div className="self-stretch justify-center items-center gap-4 inline-flex">
          <hr className="flex-1 border-neutral-100" />
          <span className="text-xs flex-shrink mx-4 text-neutral-700 tracking-[0.96px] uppercase leading-[14px]">
            or
          </span>
          <hr className="flex-1 border-neutral-100" />
        </div>

        {/* Step by step instructions option */}
        <OptionsCard
          option="Add step by step instructions"
          handleOnClick={handleClickAddStepByStepInstructions}
        />
      </div>
    </PopUpContainer>
  );
};

export default AddInstructionsPopUp;
